import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { ReportResponse } from '../../responses/report/report.response';

@Injectable({
  providedIn: 'root'
})
export class TemplateService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  viewTemplate(idTemplate: number): Observable<ReportResponse>{
    let uri = `Template/Sadt`;
    
    if(idTemplate)
      uri = uri + `?idTemplate=${idTemplate}`;

    return this.httpClient.get<ReportResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiReport) + uri,this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
